var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 15,
    viewBox: "0 0 11 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.17891 14.625C7.67422 12.7441 11 8.18555 11 5.625C11 2.51836 8.5376 0 5.5 0C2.46354 0 0 2.51836 0 5.625C0 8.18555 3.35156 12.7441 4.82109 14.625C5.17344 15.0732 5.82656 15.0732 6.17891 14.625ZM5.5 7.5C4.4888 7.5 3.66667 6.65918 3.66667 5.625C3.66667 4.59082 4.4888 3.75 5.5 3.75C6.5112 3.75 7.33333 4.59082 7.33333 5.625C7.33333 6.65918 6.5112 7.5 5.5 7.5Z",
    fill: "#FA6900"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarker);
export default __webpack_public_path__ + "static/media/marker.33cd948cbc3added2ad497bd6746555e.svg";
export { ForwardRef as ReactComponent };